import { api } from 'services/api';
import { SelectContentProps } from 'components/ui/Forms';
import { Carrier } from 'contracts/Carriers';
import { useAuth } from 'hooks/auth';

export function useCarrier() {
  const { token } = useAuth();
  const getCarriers = async (): Promise<SelectContentProps[]> => {
    const { data } = await api.get('/carriers?asList=1', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return data.map((carrier: Carrier) => ({
      value: carrier.id,
      name: `${carrier.tradeName} - ${carrier.document}`,
    }));
  };

  return { getCarriers };
}
